import { ItdsMode } from '@reliance/types/enums/ItdsMode';
import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Card from 'react-bootstrap/Card';

type TrustAccountsProps = {
  facility: Facility;
};

const formatItdsMode = (itdsMode: ItdsMode) => {
  if (itdsMode == ItdsMode.DISABLED) {
    return 'Disabled';
  }
  if (itdsMode == ItdsMode.FULL) {
    return 'Full';
  }
  return 'Legacy';
};

const TrustAccounts: React.FC<TrustAccountsProps> = (props) => {
  return (
    <Card>
      <Card.Header>Trust Accounts</Card.Header>
      <Card.Body>
        <div>Mode: {formatItdsMode(props.facility.itdsMode)}</div>
        <div>Site ID: {props.facility.itdsSiteId}</div>
        <div>Vendor ID: {props.facility.itdsVendorId}</div>
        <div>Vendor Login: {props.facility.itdsVendorLogin}</div>
        <div>Vendor Password: {props.facility.itdsVendorPassword}</div>
      </Card.Body>
    </Card>
  );
};

export default TrustAccounts;
